export function getFileIcon(attachment) {
  if (attachment.mime_type.startsWith('image/')) {
    return 'image'
  } else if (attachment.mime_type.startsWith('video/')) {
    return 'video'
  } else if (attachment.mime_type.startsWith('audio/')) {
    return 'audio'
  } else if (attachment.mime_type === 'application/pdf') {
    return 'file-pdf'
  } else if (attachment.mime_type === 'text/csv') {
    return 'file-csv'
  } else if (
    [
      'application/vnd.openxmlformats-officedocument.presentationml.presentation',
      'application/vnd.ms-powerpoint',
    ].includes(attachment.mime_type)
  ) {
    return 'file-powerpoint'
  } else if (
    [
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'application/msword',
    ].includes(attachment.mime_type)
  ) {
    return 'file-word'
  } else if (
    [
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'application/vnd.ms-excel',
    ].includes(attachment.mime_type)
  ) {
    return 'file-excel'
  } else if (
    attachment.mime_type === 'application/zip' ||
    attachment.mime_type === 'application/x-zip-compressed'
  ) {
    return 'file-zipper'
  }

  return 'arrow-up-right-from-square'
}
